import React, { useEffect, useState } from "react";
import userChatUserList from "./chatuserUtils";
import "./chatuserlist.scss";
import { images } from "../../../utils/customFn";
import { useSelector } from "react-redux";

const ChatUserList = ({
  onSelectUser,
  otherUser,
  setOtherUser,
  unreadCounts,
  listData,
  setListData,
}) => {
  const { loading } = userChatUserList({ setOtherUser, setListData });
  const { profileData } = useSelector((state) => state.userAuth);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredList = listData?.filter((user) =>
    user?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user?.email?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="chat-list">
      <div className="desktop_menu">
        {/* Current User Info */}
        <div className="chat_sidebar_current_user mb-4">
          <div className="d-flex gap-4">
            <div className="l">
              <img src={profileData?.image || images["user.png"]} alt="" />
            </div>
            <div className="l">
              <h5>{profileData?.name}</h5>
              <p className="chat_active_user_email">{profileData?.email}</p>
            </div>
          </div>
        </div>

        {/* Search Input */}
        <input
          type="text"
          placeholder="Search"
          className="search-bar desktop_chat_user_search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        {/* User List */}
        <div className="desktop-chat-list">
          {filteredList?.length > 0 ? (
            filteredList.map((user) => (
              <div
                key={user?.id}
                className={`contact-item ${
                  otherUser?.id === user?.id ? "active" : ""
                }`}
               onClick={() => {
                  if (otherUser?.id !== user?.id) {
                    onSelectUser(user);
                  }
                }}
              >
                <img
                  src={user?.profile_picture || images["dummy.png"]}
                  alt={user?.name}
                  className="avatar"
                />
                <div className="contact-info">
                  <div className="contact-name d-flex justify-content-between">
                    <div className="d-flex">
                      <p>{user.name}</p>
                      {user?.unreadCount > 0 && (
                        <span className="messgecountcircle">
                          {user?.unreadCount > 99 ? "99+" : user?.unreadCount}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="contact-message-preview mt-1">
                    {user?.latestMessage?.message?.length > 40
                      ? user.latestMessage.message.slice(0, 40) + "..."
                      : user?.latestMessage?.message || ""}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center mt-3 text-muted">No users found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatUserList;
